import React, {useEffect} from "react";
import {hideMenu} from "../../Funlove/Components";

function BreadCrumb (props) {
    useEffect(() => {
        hideMenu();
    }, []);
    return false;
}
export default BreadCrumb;
